"use client";

import { cn } from "@borderless/ui/lib/utils";
import { useEffect, useState, type FC } from "react";
import type { ToCItem } from "../../_utils/table-of-contents";

export const TableOfContents: FC<{
  tableOfContentsItems: ToCItem[];
  className?: string;
}> = ({ tableOfContentsItems, className }) => {
  const [activeId, setActiveId] = useState<string | undefined>();
  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    tableOfContentsItems.forEach((item) => {
      const element = document.getElementById(item.anchorId);
      if (element) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry?.isIntersecting) {
              setActiveId(item.anchorId);
            }
          },
          {
            rootMargin: "-10% 0px -80% 0px",
            threshold: 0.5,
          },
        );
        observer.observe(element);
        observers.push(observer);
      }
    });
    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [tableOfContentsItems]);
  return (
    <div className={cn(className)}>
      <ol>
        {tableOfContentsItems.map((item, index) => {
          const activeIndex = tableOfContentsItems.findIndex(
            (item) => item.anchorId === activeId,
          );
          const completed = activeIndex >= index;
          return (
            <li key={item.anchorId} className="flex items-stretch gap-1">
              <div
                className={cn(
                  "w-2 shrink-0 bg-accent",
                  completed && "bg-bright-green",
                  activeId === item.anchorId && "rounded-b-full",
                  index === 0 && "rounded-t-full",
                  index === tableOfContentsItems.length - 1 && "rounded-b-full",
                )}
              >
                <div
                  className={cn(
                    "h-full w-full",
                    activeId === item.anchorId && "rounded-full bg-bright-pink",
                  )}
                />
              </div>
              <a
                href={`#${item.anchorId}`}
                onClick={() => {
                  // document.documentElement.style.scrollBehavior = "smooth";
                  setActiveId(item.anchorId);
                }}
                className={cn(
                  "block grow px-2 py-2 text-sm font-semibold text-muted-foreground",
                  activeId === item.anchorId && "font-semibold text-foreground",
                )}
              >
                {item.title}
              </a>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
